export default "__VITE_ASSET__lIwaG2W1__"